import type { ExcDtccUtcV1UtcFixSessionKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const UTC_FIX_SESSION_BASE_PATH = getResolvedPath('/clearing/operations/trade/utc-fix-session');

export const getUtcFixSessionPath: EntityPathBuilder<ExcDtccUtcV1UtcFixSessionKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return UTC_FIX_SESSION_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.sessionId) {
        return undefined;
      }

      return getResolvedPath(`${UTC_FIX_SESSION_BASE_PATH}/$sessionId`, context.keys);
    }
  }
};

export function getUtcFixSessionDetailPath(sessionId: string | undefined) {
  if (!sessionId) {
    return undefined;
  }

  return getUtcFixSessionPath({ kind: 'detail', keys: { sessionId } });
}
